document.addEventListener("DOMContentLoaded", function () {
  const carousels = document.querySelectorAll(".collection-carousel");

  carousels.forEach((carousel) => {
    const slider = carousel.querySelector(".collection-carousel__slider");
    const prevBtn = carousel.querySelector(".custom-prev-btn");
    const nextBtn = carousel.querySelector(".custom-next-btn");
    const isAutoplay = carousel.dataset.autoplay === "true";
    const autoplaySpeed = parseInt(carousel.dataset.autoplaySpeed) || 5000;
    const desktopSlides = parseInt(carousel.dataset.desktopSlides) || 5;
    const mobileSlides = parseInt(carousel.dataset.mobileSlides) || 1;
    const gap = parseInt(carousel.dataset.gap) || 16;

    // Set gap as CSS variable for styling
    carousel.style.setProperty("--gap-custom", gap + "px");

    // Initialize Slick slider
    $(slider).slick({
      slidesToShow: desktopSlides,
      slidesToScroll: 1,
      arrows: false, // Disable default arrows
      dots: false,
      infinite: true,
      autoplay: isAutoplay,
      autoplaySpeed: autoplaySpeed,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: mobileSlides,
            slidesToScroll: 1,
          },
        },
      ],
    });

    // Set up custom navigation buttons
    prevBtn.addEventListener("click", function () {
      $(slider).slick("slickPrev");
    });

    nextBtn.addEventListener("click", function () {
      $(slider).slick("slickNext");
    });

    // Reset autoplay when custom buttons are clicked
    function resetAutoplay() {
      if (isAutoplay) {
        $(slider).slick("slickPlay");
      }
    }

    prevBtn.addEventListener("click", resetAutoplay);
    nextBtn.addEventListener("click", resetAutoplay);
  });
});
